// Birthdays are stored as "YYYY-MM-DD", or "--MM-DD" when the client gave
// only the day and month (the API's catalog.BirthdayMonthDay reads both).

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

// formatBirthday: "14 March 1990", or "14 March" without a year. Null when
// the stored value can't be read.
export function formatBirthday(stored: string): string | null {
  const m = /^(\d{4}|-)-(\d{2})-(\d{2})$/.exec(stored)
  if (!m) return null
  const month = Number(m[2])
  const day = Number(m[3])
  if (month < 1 || month > 12 || day < 1 || day > 31) return null
  return m[1] === '-' ? `${day} ${MONTHS[month - 1]}` : `${day} ${MONTHS[month - 1]} ${m[1]}`
}

export interface BirthdayDraft {
  day: string
  month: string // '1'..'12', or '' for none
  year: string
}

export function toBirthdayDraft(stored: string | null): BirthdayDraft {
  const m = stored ? /^(\d{4}|-)-(\d{2})-(\d{2})$/.exec(stored) : null
  if (!m) return { day: '', month: '', year: '' }
  return { day: String(Number(m[3])), month: String(Number(m[2])), year: m[1] === '-' ? '' : m[1] }
}

// fromBirthdayDraft is what to store: null to clear it, or an error message.
export function fromBirthdayDraft(d: BirthdayDraft): { value: string | null } | { error: string } {
  if (d.day.trim() === '' && d.month === '' && d.year.trim() === '') return { value: null }
  const day = Number(d.day)
  const month = Number(d.month)
  const year = d.year.trim() === '' ? null : Number(d.year)
  if (!Number.isInteger(day) || !Number.isInteger(month) || month < 1 || month > 12) {
    return { error: 'Choose a day and a month.' }
  }
  if (year !== null && (!Number.isInteger(year) || year < 1900 || year > new Date().getFullYear())) {
    return { error: 'Enter the year in full, like 1990, or leave it out.' }
  }
  const check = new Date(Date.UTC(year ?? 2000, month - 1, day)) // 2000 allows 29 February
  if (check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) {
    return { error: 'That day is not in that month.' }
  }
  const mm = String(month).padStart(2, '0')
  const dd = String(day).padStart(2, '0')
  return { value: year === null ? `--${mm}-${dd}` : `${year}-${mm}-${dd}` }
}

export const BIRTHDAY_MONTHS = MONTHS
